export default __webpack_public_path__ + "static/media/mainmenu_alerts.f8f6e492.jpg";